export const identityVerificationKeys = {
	sessions: (params: {
		guest_id?: number;
		global_on_id?: number;
		user_id?: number;
	}) => ["identity-verification", "sessions", params],
	create: () => ["identity-verification", "create"],
};
